<template>
	<div id="shop">
		<div class="section">
			<div class="library-info">
				<img src="@/assets/natale2022banner.jpg" style="display:block; max-width:70%; margin: 0 auto;" align="center">
			</div>
			
		</div>
		<div class="container-desktop pad-l">
			<h1 align=center>Ci vediamo l'anno prossimo!</h1>
			<!--<div class="p-relative">
					<div class="bar">
						<Card class="bg-darker natale" title="10 lezioni small class" :image="require('@/assets/sc.jpg')"><p>Allenamenti di gruppo personalizzati di max 6 persone, in modo da garantire sempre massima qualità. Se ti piace allenarti in gruppo ed essere seguito da un coach esperto le nostre small class fanno per te!<br><br>Dopo l'acquisto puoi ritirare il buono direttamente in palestra o scrivici per riceverlo via email.<br><br><b>I pacchetti sono validi solo se regalati ad un altra persona.</b></p><p class="prezzo">120€<br><span style="color:#ffe010; font-size:0.8em;">Risparmi 30€</span></p><p class="buy"><a href="https://buy.stripe.com/bIY8yEa5r7jd9MI5kH"><button>Acquista</button></a></p></Card>
						<Card class="bg-darker natale" title="10 lezioni personal training singolo" :image="require('@/assets/pt_service.jpg')"><p>È il metodo migliore per raggiungere i tuoi risultati in modo efficiente e sicuro. Gli allenamenti sono personalizzati in base alle tue caratteristiche e obiettivi, senza lasciare nulla al caso.<br><br>Dopo l'acquisto puoi ritirare il buono direttamente in palestra o scrivici per riceverlo via email.<br><br><b>I pacchetti sono validi solo se regalati ad un altra persona.</b></p><p class="prezzo">360€<br><span style="color:#ffe010; font-size:0.8em;">Risparmi 40€</span></p><p class="buy"><a href="https://buy.stripe.com/dR6bKQ7Xj6f9cYU7sQ"><button>Acquista</button></a></p></Card>
						<Card class="bg-darker natale" title="10 lezioni personal training di coppia" :image="require('@/assets/pt_service.jpg')"><p>Le lezioni in coppia sono perfette per chi cerca sempre il massimo della personalizzazione ma preferisce allenarsi con un partner per motivarsi e spronarsi a vicenda.<br><br>Dopo l'acquisto puoi ritirare il buono direttamente in palestra o scrivici per riceverlo via email.<br><br><b>I pacchetti sono validi solo se regalati ad un altra persona.</b></p><p class="prezzo">450€<br><span style="color:#ffe010; font-size:0.8em;">Risparmi 50€</span></p><p class="buy"><a href="https://buy.stripe.com/3cs6qw7Xj6f9e2YfZn"><button>Acquista</button></a></p></Card>
					</div>
			</div>-->
		</div>
	</div>

</template>
<script>
import VideoCard from '@/components/library/VideoCard'
import Card from '@/components/home/Cardshop'
import About from '@/components/home/About'

export default {
	name: 'shop',

	components: {
		VideoCard,
		Card,
		About
	},

	data() {

		return {
			/// Authenticated user
			bShowBlogNav: false
		}
	},

	created(){
     },

	computed: {
		/**
		 * 
		 */
	},

	methods: {
		/**
		 * 
		 */
	},

	mounted() {

		window.scrollTo(0, 0)
	},

}

</script>

<style lang="stylus" scoped>

.bar
	display grid
	grid-template-columns repeat(3, 1fr)
	grid-gap 1em

	padding 1em

	@media (max-width: unit(767, px))
		grid-template-columns auto

.bar2
	display grid
	grid-template-columns repeat(2, 1fr)
	grid-gap 1em

	padding 1em

	@media (max-width: unit(767, px))
		grid-template-columns auto

.filtro
	width 100%
	background #101418
	height 3em
	margin-bottom 3em

	@media (max-width: unit(767, px))
		height 100%
		padding-bottom 0.7em

.catcont
	width 520px
	margin 0 auto
	position relative
	display flex
	padding-top 0.6em

	@media (max-width: unit(767, px))
		width 100%
		display grid

.menu-button
			height 100%
			margin 0 auto
			display none 

			@media (min-width: unit(768, px))
				display none

			>button
				height 100%

				display flex
				align-items center

				border none

				background-color transparent
				color #dcdcdc

				font-size 2em

				&:focus
					outline none
				&:hover
					background-color mix(darkish, dark)

.mobileblog
	display none

	&.show
		display none

.categoria
	text-transform uppercase
	font-size 1.1em
	font-weight bold
	margin 0 auto

	@media (max-width: unit(767, px))
		color red	

.link
	text-decoration none 
	color #dcdcdc
	transition 0.2s ease

.link:hover
	color #ffe010


.up
	position fixed
	bottom 0
	left 0
	margin-left 1em
	margin-bottom 1em
	width 2.5em
	height 2.5em
	border-radius 2.5em
	background #ffe010
	z-index 9999

.progselect
	max-width 570px
	margin 0 auto
	text-align center

	.progworkout
		max-width 490px
		margin 0 auto
		p
			text-align left
			font-size 1.2 em
			margin-left 0.7em

.divprogramma
	display grid
	grid-template-columns repeat(3, 1fr)
	grid-gap 1em

	@media (max-width: unit(560, px))
		grid-template-columns auto

.programma
	padding 0.4em 0.6em
	border none
	border-bottom 2px solid transparent
	box-sizing border-box
	background-color darkish
	color light
	font-size 1.2em

.divprova
	max-width 100%
	padding 2em
	text-align center

.provagratuita
	max-width 500px

	padding 0.6em
	border none

	background-color primary
	color dark

	font-family fontSans
	font-size 1.6em

	cursor pointer

	transition 0.2s ease

	&:focus
		outline none

.presdesc
	list-style-type none

	li:before
		content: "\2022";  /* Add content: \2022 is the CSS Code/unicode for a bullet */
		color: #ffe010; /* Change the color */
		font-weight: bold; /* If you want it to be bold */
		display: inline-block; /* Needed to add space between the bullet and the text */
		width: 1em; /* Also needed for space (tweak if needed) */
		margin-left: -1em; /* Also needed for space (tweak if needed) */

.divpres
	text-align center

	img
		display block
		margin 0 auto

.divbox
	display grid
	grid-template-columns auto
	grid-gap 1em

	@media (max-width: unit(767, px))
		grid-template-columns auto
	
	ul
		text-transform uppercase
		font-weight bold

.divul
	text-align left
	margin 0 auto
</style>
